import { $apiGet, $apiPut } from '~/utils/request'
import type { LawFirm } from '~/models'

export const Get = () => $apiGet<LawFirm>(`/v1/lawFirm`)

export const Put = (encryptionId, body) => $apiPut<void>(`/v1/lawFirm/${encryptionId}`, body)
